<template>
  <div>
    <MemberForm
      class="my-4"
      fromSection="clientTeam"
      :member="dataMember"
      @sendData="updateDataMember($event)"
    />
  </div>
</template>

<script>
import MemberForm from '@/components/team/MemberForm';
import { cloneDeep } from 'lodash';

export default {
    components: { MemberForm },
    props: {
        mutableValue: {
            type: Object,
            default: () => ({ empty: true }),
        },
    },
    data() {
        return {
            dataMember: {},
        };
    },
    created() {
        this.dataMember = cloneDeep(this.mutableValue);
    },
    methods: {
        updateDataMember(e) {
            this.$emit('sendData', e);
        },
    },
};
</script>
